module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "packages-landing"
  }, [_vm._m(0), _vm._v(" "), _c('section', {
    staticClass: "section bg-primary pricing-plans"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('div', {
    staticClass: "pricing-box z-depth-2"
  }, [_vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "pricing-action"
  }, [_c('router-link', {
    staticClass: "btn btn-primary btn-block btn-flat",
    attrs: {
      "to": "/signup"
    }
  }, [_vm._v("30 Day Free Trial")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('div', {
    staticClass: "pricing-box z-depth-2"
  }, [_vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "pricing-action"
  }, [_c('router-link', {
    staticClass: "btn btn-primary btn-block btn-flat",
    attrs: {
      "to": "/signup"
    }
  }, [_vm._v("30 Day Free Trial")])], 1)])]), _vm._v(" "), _vm._m(7)]), _vm._v(" "), _c('div', {
    staticClass: "row text-center m-t-lg",
    staticStyle: {
      "color": "white"
    }
  }, [_vm._v("\n        Please note all packages are subject to "), _c('a', {
    staticStyle: {
      "color": "white",
      "text-decoration": "underline"
    },
    on: {
      "click": _vm.openModal
    }
  }, [_vm._v("Terms and Conditions")])])])]), _vm._v(" "), _c('section', {}, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row flush"
  }, [_c('div', {
    staticClass: "col-md-4 grey-1"
  }, [_c('div', {
    staticClass: "p-a-lg"
  }, [_c('h3', {
    staticClass: "m-t-0 m-b"
  }, [_vm._v("LogBox Patient")]), _vm._v(" "), _c('p', {}, [_vm._v("LogBox allows you to share your information with your healthcare professional securely. No more paper forms needed.")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-default",
    attrs: {
      "to": "/patient"
    }
  }, [_vm._v("Learn More")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 grey-2"
  }, [_c('div', {
    staticClass: "p-a-lg"
  }, [_c('h3', {
    staticClass: "m-t-0 m-b"
  }, [_vm._v("LogBox Practice")]), _vm._v(" "), _c('p', {}, [_vm._v("Connecting Healthcare Professionals to their patients. Move your practice into the digital age. Join the LogBox community today.")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-default",
    attrs: {
      "to": "/practice"
    }
  }, [_vm._v("Learn More")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 grey-3"
  }, [_c('div', {
    staticClass: "p-a-lg"
  }, [_c('h3', {
    staticClass: "m-t-0 m-b"
  }, [_vm._v("LogBox Academic")]), _vm._v(" "), _c('p', {}, [_vm._v("A logbook and electronic portfolio for Academic Registrars, Supervisors and Heads of Departments.")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-default",
    attrs: {
      "to": "/academic"
    }
  }, [_vm._v("Learn More")])], 1)])])])]), _vm._v(" "), _c('ud-terms-modal', {
    attrs: {
      "open": _vm.modalOpen
    },
    on: {
      "close": _vm.closeModal
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "section intro"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4 white text-center text-sm-left"
  }, [_c('h1', {
    staticClass: "m-t-0"
  }, [_vm._v("Find a solution that works for your practice")]), _vm._v(" "), _c('p', {
    staticClass: "lead"
  }, [_vm._v("From only R119 per month, you can move your practice into the digital age. Join the LogBox community today.")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pricing-title"
  }, [_c('h3', [_vm._v("Single Practice")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pricing-price"
  }, [_c('span', {
    staticClass: "price-unit"
  }, [_vm._v("R")]), _vm._v("119"), _c('span', {
    staticClass: "price-tenure"
  }, [_vm._v("/month")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pricing-features"
  }, [_c('ul', [_c('li', [_vm._v("Fewer than 10 users.")]), _vm._v(" "), _c('li', [_vm._v("For every additional user, R10/month per user.")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pricing-title"
  }, [_c('h3', [_vm._v("Integrated Billing")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pricing-price"
  }, [_c('span', {
    staticClass: "price-unit"
  }, [_vm._v("R")]), _vm._v("250"), _c('span', {
    staticClass: "price-tenure"
  }, [_vm._v("/month")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pricing-features",
    staticStyle: {
      "padding-top": "20px",
      "padding-bottom": "12px"
    }
  }, [_c('ul', [_c('li', [_vm._v("Integrated with your current billing software")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-4"
  }, [_c('div', {
    staticClass: "pricing-box z-depth-2"
  }, [_c('div', {
    staticClass: "pricing-title"
  }, [_c('h3', [_vm._v("Group Practice")])]), _vm._v(" "), _c('div', {
    staticClass: "pricing-price"
  }, [_c('img', {
    staticClass: "group-practice-icon",
    attrs: {
      "src": require("assets/images/brochure/professional/5.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "pricing-features",
    staticStyle: {
      "padding-bottom": "10px"
    }
  }, [_c('ul', [_c('li', [_vm._v("Contact us and we'll be in touch.")])])]), _vm._v(" "), _c('div', {
    staticClass: "pricing-action"
  }, [_c('a', {
    staticClass: "btn btn-primary btn-block btn-flat",
    attrs: {
      "href": "mailto:contact@logbox.co.za"
    }
  }, [_vm._v("Contact Us")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8f14da80"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/brochure/Packages.vue
// module id = 669
// module chunks = 5